module.exports = __webpack_public_path__ + "static/media/chat-11.273f0bbf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/chat-11.svg
// module id = 3365
// module chunks = 6